let _items = {}

const storage = {
  setItem: (key, value) => (_items[key] = value),

  getItem: (key) => {
    if (!_items.hasOwnProperty(key)) {
      return null;
    }
    return _items[key];
  },

  removeItem: (key) => {
    delete _items[key];
    return true;
  },

  clear: () => (_items = {})
}

export default storage;



// WEBPACK FOOTER //
// ./src/core/storage/storage.js